module.exports = __webpack_public_path__ + "common/sidebar/icon-bank-99168c9a4fb722b524fc3cbd885ecad6.svg";